export default __webpack_public_path__ + "static/pattern1-63c4ab97b87e5894182e52b6b4a56ae3.webp";